import {Link} from "react-router-dom";
import {urlService} from "../../../routing/urlsService";
import * as React from "react";
import {DynamicDatagrid, Paper, MuiDataGrid} from "@leap4/frontend";
type GridColDef = MuiDataGrid.GridColDef;
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;

export const PriceRuleMatchingTagsTable = ({linkedTags, isLoading, isEmptyTable}) => {
    const columns: GridColDef[] = [
        {
            field: 'name',
            headerName: 'Name',
            width: 450,
            renderCell: (params: GridRenderCellParams) => {
                return <Link to={urlService.adServerTag(params.id.toString(), true)}><strong
                >{params.value}</strong></Link>
            }
        },
        {
            field: 'dataPoint',
            headerName: 'DataPoint',
            width: 300,
            renderCell: (params: GridRenderCellParams) => {
                return <Link to={urlService.dataPointOverview(params.value, true)}><strong
                >{params.value}</strong></Link>
            }
        },{
            field: 'campaignId',
            headerName: 'CampaignId',
            width: 100,
        },{
            field: 'side',
            headerName: 'side',
            width: 100,
        },{
            field: 'companyId',
            headerName: 'companyId',
            width: 100,
        },
        {
            field: 'publisherTag',
            headerName: 'publisherTag',
            width: 250,
            renderCell: (params: GridRenderCellParams) => {
                return <Link to={urlService.publisherTag(params.value, true)}><strong
                >{params.value}</strong></Link>
            }
        },
    ]

    function createRowData(item) {
        return {
            id: item._id,
            name: item.name,
            dataPoint: item.dataPoint,
            campaignId: item.campaignId,
            companyId: item.companyId,
            side: item.side,
            publisherTag: item.publisherTag || null,
        }
    }

    const rows = isEmptyTable? [] : linkedTags.map((tag,) =>
        createRowData(tag)
    ).filter(x=> !!x).sort((a,b) => b.impressions > a.impressions ? 1 : -1);

    return (
        <Paper sx={{margin: "20px 0", borderRadius: "16px", boxShadow: "none"}} elevation={5}>
            <DynamicDatagrid rows={rows}
                             columns={columns}
                             loading={isLoading}
                             refreshFunc={() => {}}
                             loadError={false}
                             pageSize={100}
                             style={{minHeight: `75vh`, width: '100%'}}
            />
        </Paper>
    )
}